import { articleList } from "@/mocks/articles";

export default function ArticlePreview() {
  const article = articleList[0];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20wooden%20desk%20displaying%20colorful%20spreadsheet%20data%20interface%20with%20fashion%20product%20images%2C%20surrounded%20by%20fashion%20magazines%20and%20coffee%20cup%2C%20bright%20natural%20window%20light%20from%20left%2C%20warm%20neutral%20interior%2C%20editorial%20lifestyle%20photography%20with%20clean%20airy%20composition&width=800&height=500&seq=article-preview-featured-v2&orientation=landscape"
                alt="Pandabuy spreadsheet guide and tips"
                className="w-full h-[240px] md:h-[300px] object-cover object-center"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-800 uppercase tracking-wider mb-4">
              {article.category}
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
              {article.title}
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              {article.excerpt}
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full text-[11px] font-medium bg-background-50 text-foreground-600 whitespace-nowrap border border-background-200/40"
                >
                  {tag}
                </span>
              ))}
            </div>

            <a
              href={`/article/${article.slug}`}
              className="inline-flex items-center justify-center gap-2 mt-7 px-6 py-3 rounded-full font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:translate-y-[-1px]"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}